import { register } from 'backbone-toolbar';
import { renderSearchBox } from './search-box';
import { renderSelector } from './selector';
import { renderPillControl } from './pill-control';
import { renderTextView } from './text-view';

register('search-box', renderSearchBox);
register('selector', renderSelector);
register('pill-control', renderPillControl);
register('text-view', renderTextView);

export { ToolbarView, OverridableToolbarView } from './toolbar-view';
